module.exports = __webpack_public_path__ + "static/media/01_A7_-01.246d3516.png";